import {AfterViewInit, Component, OnDestroy, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FlowChartDataService} from '../../../services/flow-chart-data.service';
import { MatSelectChange } from '@angular/material/select';
import { takeUntil } from 'rxjs/operators';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'particle-move-question-between-section-dialog',
  templateUrl: './move-question-between-section-dialog.component.html',
  styleUrls: ['./move-question-between-section-dialog.component.scss']
})
export class MoveQuestionBetweenSectionDialogComponent implements OnInit, OnDestroy, IDialogView, AfterViewInit {

  data: DialogModel;

  constructor(private flowChartDataService: FlowChartDataService,private fuseSplashScreenService:FuseSplashScreenService) {

  }

  sections: any[] = [];
  selectedSection: any;
  isCreateCopyEnabled: boolean = false;
  ngUnsubscribe = new Subject<void>();
  ngOnInit() {
    this.flowChartDataService.getDesignerSingleTopicSections().then(
      data => {
        this.sections = data[0].filter(section => section.id !== this.data.input.item.sourceSectionId);
        this.selectedSection = this.sections[0];
      }
      ,
      error => {
        console.error('getDesignerSingleTopicSections error', error);
      }
    );
  }

  ngAfterViewInit(): void {
  }
  ngOnDestroy() {
    //this.flowChartDataService.destroy();
  }

  onOkClicked(): boolean {

    if (!this.selectedSection || this.sections.length == 0 ) {
      return false;
    }
    this.data.input.destinationSection = this.selectedSection;
    this.data.input.isCreateCopyEnabled = this.isCreateCopyEnabled;
    return true;
  }

  onSelectionChange($event: MatSelectChange) {
    this.selectedSection = $event.value;
  }
}
